module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-ex-gray-on-white-8a1454dd605ea906e53104fae7c427bc.svg";